<!--  -->
<template>
  <div>
    <div class="sp_view">
      <div class="tabselecr_box">
        <div class="search_box">
          <el-input
            v-model="query.keywords"
            clearable
            style="width: 400px"
            placeholder="请输入发布编号/标题/朋友圈编号"
          />
          <el-select
            v-model="query.send_status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-select v-model="query.onlyMe" placeholder="请选择" style="margin-left:10px">
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchclick"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="rechargeclick"
          >重置</el-button>
        </div>
        <div>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
          >新增朋友圈定时消息</el-button>
        </div>
      </div>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        border
      >
        <el-table-column
          prop="sp_push_title"
          label="自有标题"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              title="自有标题"
              width="180"
              trigger="hover"
              :content="scope.row.sp_push_title"
            >
              <div slot="reference" class="sedrtw">
                {{ scope.row.sp_push_title }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="send_way_type_text"
          label="发送方式"
          align="center"
          width="100"
        />
        <el-table-column
          prop="sp_push_no"
          label="发送id"
          align="center"
          width="280"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.sp_push_no }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="sp_moments_no"
          label="朋友圈编号"
          align="center"
          width="280"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.sp_moments_no }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="send_time_text"
          label="发送时间"
          align="center"
          width="170"
        />
        <el-table-column
          prop="status_text"
          label="发送状态"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <div>
              <i
                v-if="scope.row.send_status === 1"
                class="el-icon-error"
                style="color: #f56c6c"
              />
              <i
                v-if="scope.row.send_status === 2"
                class="el-icon-success"
                style="color: #67c23a"
              />
              <i
                v-if="scope.row.send_status === 3"
                class="el-icon-circle-check"
                style="color: #67c23a"
              />
              {{ scope.row.send_status_text }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
          width="170"
        />
        <el-table-column
          prop="status_text"
          label="状态"
          align="center"
          width="110"
        >
          <template slot-scope="scope">
            <div>
              <i
                v-if="scope.row.status === 1"
                class="el-icon-success"
                style="color: #67c23a"
              />
              <i
                v-if="scope.row.status === 2"
                class="el-icon-error"
                style="color: #f56c6c"
              />
              {{ scope.row.status_text }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="tags" label="标签" align="center" width="300">
          <template slot-scope="scope">
            <div class="tag-container">
              <div
                v-for="item in scope.row.tags"
                :key="item.id"
                class="tag-wrapper"
              >
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="item"
                  style="display: flex; white-space: nowrap"
                >
                  <div slot="reference" class="tag-item">
                    {{ item }}
                    <span v-if="scope.row.tags.length > 1">,</span>
                  </div>
                </el-popover>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="real_name" label="创建人" align="center" />
        <el-table-column
          prop="created_time_text"
          label="创建时间"
          align="center"
          width="180"
        />
        <el-table-column label="操作" align="center" width="460">
          <!-- slot-scope="scope" -->
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              @click="reuse(scope.row.sp_push_no)"
            >复用</el-button>
            <el-button
              :type="
                scope.row.send_status == 3 ||
                  scope.row.send_status == 2 ||
                  scope.row.status == 2
                  ? 'info'
                  : 'primary'
              "
              size="mini"
              @click="edit(scope.row)"
            >编辑</el-button>

            <el-button
              type="info"
              size="mini"
              @click="bandtakenotes(scope.row.sp_push_no)"
            >绑定记录</el-button>
            <el-button
              type="success"
              size="mini"
              @click="look(scope.row.sp_push_no)"
            >查看</el-button>
            <el-button
              v-if="scope.row.status === 1 && scope.row.send_status === 1"
              type="warning"
              size="mini"
              @click="stopr(scope.row.sp_push_no, 2)"
            >停止任务</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="delter(scope.row.sp_push_no)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="绑定记录"
        :visible.sync="dialogVisiblenotes"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <bandnote ref="bandstaffnotesview" @updata="updata" />
      </el-dialog>
      <pagination-right
        :current-page="query.page"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  momentsPushpushList,
  momentsPushpushDel,
  momentsPushpushStop
} from '@/api/officialaccount.js'
import bandnote from './components/bandnote.vue'
export default {
  components: { PaginationRight, bandnote },
  data() {
    return {
      query: {
        page: 1,
        keywords: null,
        page_size: 10,
        send_status: 0,
        onlyMe: 2
      },
      total: null,
      loading: false,
      tableData: [],
      dialogVisiblenotes: false,
      options: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '未发送'
        },
        {
          value: 2,
          label: '已发送'
        },
        {
          value: 3,
          label: '已完成'
        }
      ],
      accountarr: [{
        value: 1,
        label: '查看组内'
      }, {
        value: 2,
        label: '我关联的'
      }]
    }
  },
  created() {
    this.list()
  },
  activated() {
    this.list()
  },
  mounted() {},
  methods: {
    edit(row) {
      console.log('row:', row)
      if (
        Number(row.send_status) === 3 ||
        Number(row.send_status) === 2 ||
        Number(row.status) === 2
      ) {
        return this.$message('朋友圈已发送或者状态停止不可编辑')
      }
      this.$router.push({
        path: '/circlefriends/sendcicle/index',
        query: {
          type: 2,
          sp_push_no: row.sp_push_no,
          reuse: 'edit'
        }
      })
    },
    reuse(sp_push_no) {
      this.$router.push({
        path: '/circlefriends/sendcicle/index',
        query: { type: 2, sp_push_no: sp_push_no, reuse: 'reuse' }
      })
    },
    submit(item) {
      console.log('item:', item)
      // this.dialogdel = false
    },
    add(type) {
      this.$router.push({
        path: '/circlefriends/sendcicle/index',
        query: { type: 1 }
      })
    },
    look(sp_push_no) {
      this.$router.push({
        path: '/circlefriends/sendcicle/index',
        query: { type: 2, sp_push_no: sp_push_no }
      })
    },
    async list() {
      this.loading = true
      const data = await momentsPushpushList(this.query)
      this.total = data.data.total
      this.tableData = data.data.list
      this.loading = false
      console.log(data)
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.query.send_status = 0
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    delter(sp_push_no) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          momentsPushpushDel({
            sp_push_no: sp_push_no
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.list()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    stopr(sp_push_no, status) {
      this.$confirm('确定要停止吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          momentsPushpushStop({
            sp_push_no: sp_push_no,
            status: status
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '停止成功!'
            })
            this.list()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    bandtakenotes(sp_push_no) {
      this.dialogVisiblenotes = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesview.send(sp_push_no)
      })
    },
    updata() {
      this.dialogVisiblenotes = false
      // this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

.sp_view {
  padding: 30px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.content_box {
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* text-align: center; */
  margin: 0 auto;
}
.sedrtw {
  width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 300px;
  max-height: 100px;
  overflow-y: auto;
  /* text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2; */
}

.tag-wrapper {
  margin-bottom: 10px;
}

.tag-item {
  margin: 0 5px;
}
</style>
